export default __webpack_public_path__ + "static/media/app_match_summary-winnings.11d47086.jpg";